import React, { FC } from "react";
import AngryIcon from "../Icons/AngryIcon";
import SadIcon from "../Icons/SadIcon";
import OkIcon from "../Icons/OkIcon";
import HappyIcon from "../Icons/HappyIcon";
import GreatIcon from "../Icons/GreatIcon";

interface IProps {
  title: "Angry" | "Sad" | "Ok" | "Happy" | "Great";
  width?: number;
  height?: number;
  color?: string;
  strokeColor?: string;
}

const ICON_COMPONENTS = {
  Angry: AngryIcon,
  Sad: SadIcon,
  Ok: OkIcon,
  Fair: OkIcon,
  Happy: HappyIcon,
  Great: GreatIcon,
};

const RenderRasaButtonIcons: FC<IProps> = ({
  title,
  width = 40,
  height = 40,
  color,
  strokeColor,
}) => {
  const IconComponent = ICON_COMPONENTS[title] || (() => null);
  return (
    <IconComponent
      width={width}
      height={height}
      color={color}
      strokeColor={strokeColor}
    />
  );
};

export default RenderRasaButtonIcons;
